
export const GameScreen = () => `
        <div id="game-screen" class="screen">
            <!-- Arka plan efekti için -->
            <div class="game-bg-overlay"></div>

            <div class="game-header">
                <div class="header-top-row">
                    <button class="icon-btn fixed-corner" id="game-menu-btn" style="position: fixed; top: 20px; left: 20px; z-index: 1000;"><i class="fas fa-bars"></i></button>
                    
                    <div class="game-center-badges">
                        <div class="score-badge" id="offline-score-badge">
                            <span class="label">SKOR</span>
                            <span id="score-display">0</span>
                        </div>
                        <!-- [NEW] Participants Characters Row -->
                        <div id="game-participants-chars" style="display: flex; gap: 5px; align-items: center; margin-right: 15px;">
                            <!-- Dynamically populated -->
                        </div>
                        <div class="question-badge">
                            <span class="label">SORU</span>
                            <span id="question-count-display">1 / 10</span>
                        </div>
                        <div class="timer-badge">
                            <span id="time-display">20</span>
                        </div>
                    </div>

                    <button class="icon-btn fixed-corner" id="game-settings-btn" style="position: fixed; top: 20px; right: 20px; z-index: 1000;"><i class="fas fa-cog"></i></button>
                </div>
                
                <div id="timer-bar">
                    <div id="timer-progress"></div>
                </div>
            </div>

            <div class="game-main-content">
                <div class="question-wrapper">
                    <div class="question-card glass-panel" data-tilt>
                        <h3 id="question-text">Soru yükleniyor...</h3>
                    </div>
                </div>

                <div id="options-container" class="options-grid">
                    <!-- Dinamik olarak doldurulacak -->
                    <button class="option-btn" data-choice="0">
                        <span class="opt-letter">A</span>
                        <span class="opt-text">Seçenek Yükleniyor...</span>
                    </button>
                    <button class="option-btn" data-choice="1">
                        <span class="opt-letter">B</span>
                        <span class="opt-text">Seçenek Yükleniyor...</span>
                    </button>
                    <button class="option-btn" data-choice="2">
                        <span class="opt-letter">C</span>
                        <span class="opt-text">Seçenek Yükleniyor...</span>
                    </button>
                    <button class="option-btn" data-choice="3">
                        <span class="opt-letter">D</span>
                        <span class="opt-text">Seçenek Yükleniyor...</span>
                    </button>
                </div>
            </div>
            
            <!-- Online Durum / Oyuncular Paneli (Optional Overlay) -->
            <div id="game-players-overlay" class="hidden"></div>
        </div>

`;
